/**
 * The type of the action which sets the list of known remote participant IDs which
 * have an active screen share.
 *
 * @returns {{
 *     type: SCREEN_SHARE_REMOTE_PARTICIPANTS_UPDATED,
 *     participantIds: Array<string>
 * }}
 */
export const SCREEN_SHARE_REMOTE_PARTICIPANTS_UPDATED
    = 'SCREEN_SHARE_REMOTE_PARTICIPANTS_UPDATED';

/**
 * The type of the action which enables or disables the feature for showing
 * video thumbnails in a two-axis tile view.
 *
 * @returns {{
 *     type: SET_TILE_VIEW,
 *     enabled: boolean
 * }}
 */
export const SET_TILE_VIEW = 'SET_TILE_VIEW';

/**
 * The type of the action which tells whether we are in carmode.
 *
 * @returns {{
*     type: SET_CAR_MODE,
*     enabled: boolean
* }}
*/
export const SET_CAR_MODE = ' SET_CAR_MODE';

/**
 * The type of the action which stores the unified LIFO priority content stack of
 * all currently active presentation items (screen share, shared video, whiteboard,
 * etherpad). The topmost pinnable item is auto-pinned to the large video.
 *
 * @returns {{
 *     type: SET_PRIORITY_CONTENT_STACK,
 *     stack: Array<{ id: string, type: string, timestamp: number }>
 * }}
 */
export const SET_PRIORITY_CONTENT_STACK = 'SET_PRIORITY_CONTENT_STACK';
